import React from 'react';
import { ButtonGroup, Fade } from '@material-ui/core';

import { ContentHeader, NewItemButton } from '@ldx-dmp/Common/components';

import Context from '../../context';

import DataTable from '../DataTable';

const List = () => (
  <Context.Consumer>
    {values => (
      <Fade in>
        <>
          <ContentHeader title="Equipment">
            <ButtonGroup variant="contained" color="primary">
              <NewItemButton text="Add Equipment" onClick={values.onNewItemClick} />
            </ButtonGroup>
          </ContentHeader>
          <DataTable />
        </>
      </Fade>
    )}
  </Context.Consumer>
);

export default List;
